/// <reference path="../../../../Scripts/typings/durandal/durandal.d.ts" />
/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
/// <reference path="../../../../Scripts/typings/q/Q.d.ts" />
/// <reference path="../../../../Scripts/typings/linq/linq.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator.throw(value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};
define('areas/home/viewmodels/shell',["require", "exports", "durandal/app", "plugins/router", "models/portal", "models/account", "services/trace", "services/settings", "services/httpclient", "common/viewmodelbase", "areas/home/model/dto", "common/string", "areas/home/model/sidebar", "areas/home/viewmodels/shellextender", "common/parts", "areas/home/parts/loadmymodules", "areas/home/parts/loadnavigation", "areas/home/parts/mapmodulestorouter", "areas/home/parts/maptonavigationmodel", "areas/home/commands/logincommand", "areas/home/commands/logoutcommand", "areas/home/commands/changecolorcommand", "areas/home/commands/navigatecommand", "areas/home/commands/showhelpcommand", "areas/widgetmanager/viewmodels/index"], function (require, exports, App, Router, Portal, Account, Trace, Configuration, Http, ViewModel, Model, Strings, Sidebar, ShellExtender, Parts, LoadMyModules, LoadNavigation, MapModulesToRouter, MapToNavigationModel, LoginCommand, LogoutCommand, ChangeColorCommand, NavigateCommand, ShowHelpCommand, WidgetManager) {
    "use strict";
    var ShellViewModel = (function (_super) {
        __extends(ShellViewModel, _super);
        //#region ctor
        function ShellViewModel() {
            var _this = this;
            _super.call(this);
            this._moduleMainChildCrumbItemsSubscription = null;
            this._moduleCrumbItemsSubscription = null;
            this._isInitialized = false;
            this._unauthorizedRoutes = ["changepassword", "login"];
            this._deepLink = null;
            this.user = Account.Principal.current;
            this.isAuthenticated = Account.Session.isAuthenticated;
            this.isRouterActivated = false;
            this.crumbs = [];
            this.navigationTree = [];
            this.groupedNavigationItems = [];
            this.shortCuts = [];
            this.searchResult = [];
            this.viewType = 'UserType';
            this.allowCustomization = false;
            this.mailbox = null;
            this.usermanagement = null;
            this.officeNewsIsActivated = false;
            this.taxLawNewsIsActivated = false;
            this.activitiesAreActivated = false;
            this.isClientUser = false;
            this.notifications = 0;
            this.loginCommand = new LoginCommand();
            this.changeColorCommand = new ChangeColorCommand();
            this.showHelpCommand = null;
            this.leftPanels = [];
            this.rightPanels = [];
            this.showCopyrightLogo = true;
            this.ssoEnabled = false;
            this.openIntegrationUrl = "/open-integration";
            this.messagesDocumentsUrl = "/messages-documents";
            this.mtdfvUrl = "/mtdfv";
            this.redirectCookieName = "redirectOneClickModule";
            App.title = $.t("app:modules.common.app_name", { ifMissing: "AOC" });
            Portal.Context.shell = this;
            this.router = Router;
            this.title = "Shell";
            this.router.makeRelative({ moduleId: 'areas' });
            ko.track(this, ["logoUrl", "user", "isAuthenticated", "isRouterActivated", "crumbs", "navigationTree", "shortCuts", "viewType", "searchSymbol", "searchResult", "groupedNavigationItems",
                "currentNode", "mailbox", "usermanagement", "officeNewsIsActivated", "taxLawNewsIsActivated", "notifications", "activitiesAreActivated", "isClientUser", "showLoginDialog",
                "leftPanels", "rightPanels", "allowCustomization", "contentDialog", "showCopyrightLogo"
            ]);
            this.extender = new ShellExtender(this);
            App.on("pushCurrentNode", (function (x) { return x(_this.currentNode); }), this);
            App.on("pushNotifications", (function (x) { return _this.notifications = x; }), this);
            App.on("tokenTimeOut", this.onTokenTimeOut, this);
            App.on("activityTimeOut", this.onActivityTimeOut, this);
            App.on('changeAvatar', function () { return _this.updateAvatar(); });
        }
        //#endregion
        ShellViewModel.prototype.onActivated = function (context) {
            return __awaiter(this, void 0, Promise, function* () {
                yield Configuration.Settings.initialize();
                this.userManager = Configuration.Settings.createUserManager();
                this.practiceName = Configuration.Settings.environment.userManager.aaaConfiguration.practiceName;
                this.ssoEnabled = Configuration.Settings.environment.userManager.aaaConfiguration.isSSOEnabled;
                this.AAAuserCheck = Configuration.Settings.environment.userManager.type === "trippleA";
                if (Configuration.Settings.useHelpSystem) {
                    this.showHelpCommand = new ShowHelpCommand();
                }
                this.showCopyrightLogo = Configuration.Settings.environment.getCustomValue("ShowCopyrightLogo", true) === "true";
                this.logoutCommand = new LogoutCommand(this.router, this.userManager, this.applications);
                this.navigateCommand = new NavigateCommand(this.router, this.userManager, this.applications);
                this.sidebar = new Sidebar(this.navigateCommand);
                this.extender.initialize();
                this.logoUrl = Configuration.Settings.mainLogoPath;
                this.logoHeight = Configuration.Settings.environment.getCustomValue("BannerLogoHeight", 20);
                if (!Account.Session.isAuthenticated && window.location.hash.indexOf("#id_token") < 0) {
                    if (window.location.hash !== "") {
                        if (!Enumerable.From(this._unauthorizedRoutes).Any(function (x) { return window.location.hash.indexOf(x) > 0; })) {
                            this._deepLink = window.location.hash.replace("#", "");
                            window.location.hash = "";
                            var expirationTime = new Date(new Date().getTime() + 120000);
                            if (this._deepLink.toLowerCase() === this.openIntegrationUrl.toLowerCase() ||
                                this._deepLink.toLowerCase() === this.messagesDocumentsUrl ||
                                this._deepLink.toLowerCase() === this.mtdfvUrl.toLowerCase()) {
                                document.cookie = this.redirectCookieName + "=" + this._deepLink.toLowerCase() + ";expires=" + expirationTime.toUTCString() + ";path=/;";
                            }
                        }
                    }
                }
                this.activitiesAreActivated = Account.Principal.current.memberType === "client_postmaster";
                this.isClientUser = Account.Principal.current.memberType === "client_postmaster";
                var LIGHT_FOREGROUND = "#ffffff";
                var DARK_FOREGROUND = "#474747"; // DARK_FOREGROUND used to be #000000 but was changed following a request of the UX team
                try {
                    var channel = new Http.Channel();
                    var message = yield channel.getData("/api/configuration/subdomains/" + Configuration.Settings.getPortalDomain() + "/theme/css", Http.ServiceTarget.publicApi);
                    var backgroundColor = message.split(';')[3].split(':')[1];
                    var rgbColor = this.colorNameToRGB(backgroundColor);
                    var sep = rgbColor.indexOf(",") > -1 ? "," : " ";
                    var rgb = rgbColor.substr(4).split(")")[0].split(sep);
                    var rgbBackground = {
                        r: parseInt(rgb[0]),
                        g: parseInt(rgb[1]),
                        b: parseInt(rgb[2])
                    };
                    var luminance = (rgbBackground.r * 299 + rgbBackground.g * 587 + rgbBackground.b * 114) / 1000;
                    this.contrastForeground = luminance > 125 ? DARK_FOREGROUND : LIGHT_FOREGROUND;
                }
                catch (reason) {
                    this.contrastForeground = LIGHT_FOREGROUND;
                }
                return this.initialize();
            });
        };
        ShellViewModel.prototype.colorNameToRGB = function (color) {
            var d = document.createElement("div");
            d.style.color = color;
            document.body.appendChild(d);
            //Color in RGB 
            var rgbColor = window.getComputedStyle(d).color;
            document.body.removeChild(d);
            return rgbColor;
        };
        //#region event handling
        ShellViewModel.prototype.onTokenTimeOut = function () {
            if (Account.Session.isExpired) {
                var alertMessage = $.t("app:modules.home.message_sessionExpired", { ifMissing: "Ihre Sitzung ist leider abgelaufen. Bitte melden Sie sich erneut an." });
                alert(alertMessage);
                this.userManager.signOut();
                this.applications.clear();
                this.router.navigate("#");
                this.reset();
                App.trigger("authentication", true);
                window.location.reload();
            }
        };
        ShellViewModel.prototype.onActivityTimeOut = function () {
            App.showDialog("areas/autologout/viewmodels/autologout", this);
        };
        ShellViewModel.prototype.triggerActivityTimeOut = function () {
            Account.Session.clear();
            this.userManager.signOut();
            this.applications.clear();
            this.reset();
        };
        ShellViewModel.prototype.onAuthenticationChanged = function () {
            var that = this;
            this.reset();
            if (Account.Session.isAuthenticated) {
                that.startPortalContext()
                    .then(function (x) {
                    var link = that.convertPortalUri(that._deepLink);
                    if (link != null)
                        that.router.navigate(link, true);
                    that._deepLink = null;
                });
            }
        };
        ShellViewModel.prototype.onSearchExecuted = function (symbol) {
            var _this = this;
            this.searchResult.removeAll();
            if (symbol == null || symbol.length == 0)
                return;
            var func = function (n) {
                if (n.type === "Application" && n.name.toLowerCase().indexOf(symbol.toLowerCase()) > -1) {
                    _this.searchResult.push(n);
                }
                // childs
                Enumerable.From(n.children)
                    .ForEach(function (child) { return func(child); });
            };
            func(this._navigation);
        };
        ShellViewModel.prototype.onRouteChanged = function (instruction) {
            try {
                // clear last view.
                jQuery("#moduleContent").children().children().remove();
                this.searchSymbol = "";
                // handle normal process
                var segments = instruction.fragment == "" ? [] : instruction.fragment.split("/");
                var node = this.findNodeFor(instruction);
                if (node == null)
                    return;
                if (node.uri.fragment == "" && segments.length > 0) {
                    this.clearNavigationUI();
                    this.viewType = "Unknown";
                    return;
                }
                // build navigation ui
                this.setCurrentNode(node);
            }
            catch (err) {
                alert(err);
            }
        };
        //#endregion
        ShellViewModel.prototype.switchUser = function (item) {
            var _this = this;
            var identityId = Account.Principal.current.identityId;
            var userName = Account.Principal.current.identityName;
            if (item != null) {
                this.userManager.signOutSwitchUser();
                this.applications.clear();
                var request = new Account.Requests.ProfileLoginRequest(Configuration.Settings.getPortalDomain(), userName, identityId, item.networkMemberId);
                this.userManager.signIn(request)
                    .then(function (x) {
                    _this.reset();
                    _this.router.navigate("#");
                    App.trigger("authentication", true);
                    location.reload();
                });
            }
        };
        ShellViewModel.prototype.switchUserAccount = function () {
            this.userManager.switchUserAccount();
        };
        //#region tools
        ShellViewModel.prototype.initialize = function () {
            return __awaiter(this, void 0, Promise, function* () {
                this.attach();
                this.mapDefaultRoutes();
                // alte session weg, bei DirektLogin => wichtig, ADDISON
                var locationSearch = window.location.search;
                var isDirectLogin = ["nid=", "session=", "secret=", "showembedded="].some(function (param) { return locationSearch.includes(param); });
                if (isDirectLogin && Account.Session.isAuthenticated) {
                    Account.Session.clear();
                    this.applications.clear();
                    this.reset();
                }
                // anmeldevorgang
                if (Account.Session.isAuthenticated) {
                    if (Account.Principal.current.shouldChangePassword && Configuration.Settings.environment.userManager.type === 'simple') {
                        yield this.logoutCommand.execute(null);
                    }
                    else {
                        return this.startPortalContext();
                    }
                }
                // deep link portal
                if (Strings.contains(window.location.search, "uri=") && this._deepLink == null) {
                    this._deepLink = locationSearch.replace("?", "");
                }
                var hashValue = window.location.hash;
                if (hashValue.indexOf("_token") >= 0) {
                    window.location.hash = "";
                }
                try {
                    yield this.activateRouter();
                    if (hashValue.indexOf("#id_token") >= 0) {
                        yield this.userManager.signInFromIdToken(hashValue);
                    }
                    else if (hashValue.indexOf("#access_token") >= 0) {
                        yield this.userManager.signInFromAccessToken(hashValue);
                    }
                    else if (window.location.search.indexOf("code") >= 0) {
                        yield this.userManager.signInFromAuthorizationCode(locationSearch);
                    }
                    else if (Account.Session.hasRefreshToken()) {
                        yield this.userManager.signInFromRefreshToken();
                    }
                    else if (Strings.contains(window.location.search, "nid=")) {
                        yield this.userManager.signInFromNid(locationSearch);
                    }
                    else if (Strings.contains(window.location.search, "secret=")) {
                        yield this.userManager.signInFromSecret(locationSearch);
                    }
                    else if (Strings.contains(window.location.search, "session=")) {
                        yield this.userManager.signInFromSessionId(locationSearch);
                    }
                    else if (!hashValue || hashValue === "#") {
                        this.userManager.showDialog();
                    }
                    if (locationSearch !== "") {
                        var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
                        if (window.location.hash !== "") {
                            url += window.location.hash;
                        }
                        history.replaceState("", "", url);
                    }
                }
                catch (error) {
                    Trace.traceError(error, null, "", true);
                }
            });
        };
        ShellViewModel.prototype.startPortalContext = function () {
            return __awaiter(this, void 0, Promise, function* () {
                Account.Session.guardUserActivity();
                Account.Session.setupAppInsights();
                var progress = new Parts.Progress(this.taskManager);
                var mapModulesToRouter = Parts.PartBinder.bind(new MapModulesToRouter(this.router), progress.process.bind(progress));
                var mapToNavigationModel = Parts.PartBinder.bind(new MapToNavigationModel(), mapModulesToRouter.process.bind(mapModulesToRouter));
                var join = Parts.PartBinder.bind(new Parts.Join(), mapToNavigationModel.process.bind(mapToNavigationModel));
                var loadMyModules = Parts.PartBinder.bind(new LoadMyModules(this.applications), join.first.bind(join));
                var loadNavigation = Parts.PartBinder.bind(new LoadNavigation(), join.second.bind(join));
                var workStatus = $.t("app:modules.home.message_oneclickInit", { ifMissing: "ADDISON OneClick wird initialisiert." });
                // Start the progress
                progress.start(workStatus, function () {
                    loadMyModules.process({});
                    loadNavigation.process({});
                });
                try {
                    // Wait for the progress output to finish
                    var data = yield new Promise(function (resolve) {
                        progress.output.connect(function (data) { return resolve(data); });
                    });
                    // Process the result
                    this._navigation = data.item3;
                    this._modules = data.item2;
                    this.setHomeApps(this._modules);
                    this.setCurrentNode(this._navigation);
                    yield this.activateRouter();
                    this.sidebar.buildUp(this._navigation, this.currentNode);
                    App.trigger("appcues", true);
                    App.trigger("customcss", true);
                    return true;
                }
                catch (error) {
                    console.error('Error in startPortalContext:', error);
                    throw error;
                }
            });
        };
        ShellViewModel.prototype.activateRouter = function () {
            return __awaiter(this, void 0, Promise, function* () {
                this.router.buildNavigationModel();
                // .mapUnknownRoutes((instruction) => {
                //     alert("Shell: not found: " + instruction.fragment);
                // });
                if (!this.isRouterActivated) {
                    this.isRouterActivated = true;
                    try {
                        // Await the activation of the router
                        var result = yield this.router.activate();
                        return result; // Return the result of the activation
                    }
                    catch (error) {
                        console.error('Error activating router:', error);
                        throw error; // Rethrow the error for further handling
                    }
                }
                return true; // Return true if the router was already activated
            });
        };
        ShellViewModel.prototype.setHomeApps = function (modules) {
            var mailBoxItemId = "1e08b4cf-3baa-49e9-b266-ad8a8aa984dc";
            this.mailbox = this.findNodeForApp(this._navigation, mailBoxItemId);
            var usermanagementItemId = "bb0bd3a1-8f77-4775-95e8-4a9a36855eee";
            this.usermanagement = this.findNodeForApp(this._navigation, usermanagementItemId);
            var officeNewsItemId = "e19e6da9-3135-4b67-8188-f75cc1e22617";
            this.officeNewsIsActivated = this.findApp(officeNewsItemId) != null;
            var taxNewsItemId = "4ab21477-fab0-494b-b7a4-91d2025d4c77";
            this.taxLawNewsIsActivated = this.findApp(taxNewsItemId) != null;
            //var activitiesItemId = "72D92CC2-473F-4563-9EC4-84F3F6108852";
            this.activitiesAreActivated = Account.Principal.current.memberType === 'client_postmaster'
                || Account.Principal.current.memberType === 'client_clerk';
            this.isClientUser = Account.Principal.current.memberType === "client_postmaster";
        };
        ShellViewModel.prototype.setCurrentNode = function (node) {
            var _this = this;
            this.currentNode = node;
            this.viewType = this.currentNode.type;
            if (this.currentNode.type !== "ApplicationLink") {
                this.clearNavigationUI();
                var nodeType = this.currentNode.type;
                var children = this.currentNode.type == "ApplicationLink" ? this.currentNode.parent.children : this.currentNode.children;
                var list = nodeType == "Application" || nodeType === "ApplicationLink" ? this.shortCuts : this.navigationTree;
                Enumerable.From(children)
                    .ForEach(function (child) {
                    list.push(child);
                });
                // gruppierung
                Enumerable.From(list)
                    .GroupBy(function (x) { return x.groupId; })
                    .ForEach(function (group) {
                    if (_this.currentNode.groups) {
                        for (var i = 0; i < _this.currentNode.groups.length; i++) {
                            if (_this.currentNode.groups[i].key === group.Key()) {
                                var itm = {
                                    showAddWidgets: _this.currentNode.groups[i].showAddWidgets,
                                    key: group.Key(),
                                    list: group.ToArray()
                                };
                            }
                        }
                    }
                    _this.groupedNavigationItems.push(itm);
                });
            }
            if (this.sidebar.items.length > 0)
                this.sidebar.setCurrentNode(node);
            this.buildCrumbs(this.currentNode);
        };
        ShellViewModel.prototype.buildCrumbs = function (node) {
            var _this = this;
            var crumbs = [];
            var iterator = node;
            while (iterator.parent != null) {
                crumbs.push(Portal.BreadCrumbItem.from(iterator.name, iterator.icon, iterator.thumbnail, iterator, function (item) { return _this.navigateCommand.execute(item.source); }));
                iterator = iterator.parent;
            }
            this.crumbs.removeAll();
            Enumerable.From(crumbs)
                .Reverse()
                .ForEach(function (x) {
                _this.crumbs.push(x);
            });
        };
        ShellViewModel.prototype.clearNavigationUI = function () {
            this.crumbs.removeAll();
            this.groupedNavigationItems.removeAll();
            this.searchResult.removeAll();
            this.shortCuts.removeAll();
            this.navigationTree.removeAll();
        };
        ShellViewModel.prototype.convertPortalUri = function (source) {
            if (source == null || source.indexOf("portal://") < 0)
                return source;
            var uniqueItemId = Portal.PortalUri.mapToUniqueItemId(source);
            if (uniqueItemId != null) {
                var node = this.findNodeForApp(this._navigation, uniqueItemId.toLowerCase());
                if (node != null)
                    return node.uri.absolute;
            }
            return null;
        };
        ShellViewModel.prototype.reset = function () {
            this.isAuthenticated = Account.Principal.current !== null;
            this.user = Account.Principal.current;
            this.clearNavigationUI();
            this._navigation = null;
            this.currentNode = null;
        };
        ShellViewModel.prototype.attach = function () {
            var that = this;
            if (that._searchSubscription != null)
                that._searchSubscription.dispose();
            if (that._routerItemSubscription != null)
                that._routerItemSubscription.dispose();
            App.off("authentication", that.onAuthenticationChanged, that);
            App.on("authentication", that.onAuthenticationChanged, that);
            // Track page navigation events in app insights
            if (window.appInsights) {
                that.router.on('router:navigation:processing', function (instruction) {
                    that._routerInstructionModule = instruction.config.moduleId;
                    window.appInsights.startTrackPage(that._routerInstructionModule);
                });
                that.router.on('router:navigation:complete', function () {
                    window.appInsights.stopTrackPage(that._routerInstructionModule);
                });
            }
            else {
                console.log("Shell Attach: Application Insights SDK not found");
            }
            that._searchSubscription = ko.getObservable(that, "searchSymbol").subscribe(that.onSearchExecuted, that);
            that._routerItemSubscription = that.router.activeItem.subscribe(function (item) {
                that.onRouteChanged(that.router.activeInstruction());
                that.bindModuleBreadCrumbItems(item);
            }, that);
        };
        ShellViewModel.prototype.mapDefaultRoutes = function () {
            this.router.map([
                { route: "", moduleId: "home/viewmodels/home", title: "Home", nav: false },
                { route: "home", moduleId: "home/viewmodels/home", title: "Home", nav: true },
                { route: "changePassword", moduleId: "account/viewmodels/changepassword", title: "ChangePassword", nav: false },
                { route: "login", moduleId: "account/viewmodels/login", title: "Login", nav: false },
            ]);
        };
        ShellViewModel.prototype.saveUserSettingsChanges = function () {
            var userTailsSettings = [];
            Enumerable.From(this.navigationTree).ForEach(function (node) {
                userTailsSettings.push({
                    groupUID: node.groupId,
                    tileUID: node.shopId,
                    isHidden: node.isHidden
                });
            });
            this.userManager.saveSettings("tile-visibility", { userTailsSettings: userTailsSettings });
        };
        ShellViewModel.prototype.findNodeForApp = function (node, uniqueId) {
            if (node.application != null && node.application.uniqueItemId == uniqueId)
                return node;
            if (node.children.length > 0) {
                for (var n in node.children) {
                    var tmp = node.children[n];
                    var item = this.findNodeForApp(tmp, uniqueId);
                    if (item != null)
                        return item;
                }
            }
            return null;
        };
        ShellViewModel.prototype.findApp = function (uniqueItemId) {
            var item = Enumerable.From(this._modules)
                .FirstOrDefault(null, function (m) { return m.uniqueItemId == uniqueItemId; });
            return item;
        };
        ShellViewModel.prototype.updateAvatar = function () {
            jQuery("#avatar").css('background-image', 'url(' + Account.Principal.current.avatar + ')');
        };
        //#endregion
        //#region module bread crumb
        ShellViewModel.prototype.bindModuleBreadCrumbItems = function (item) {
            if (this._moduleMainChildCrumbItemsSubscription != null)
                this._moduleMainChildCrumbItemsSubscription.dispose();
            if (this._moduleCrumbItemsSubscription != null)
                this._moduleCrumbItemsSubscription.dispose();
            // bind
            if (item.breadCrumb != null) {
                this.bindModuleMainChildCrumbItems(item);
                this.bindModuleCrumbItems(item);
            }
        };
        ShellViewModel.prototype.bindModuleMainChildCrumbItems = function (item) {
            // add new
            var moduleItem = Enumerable.From(this.crumbs).Last();
            Enumerable.From(item.breadCrumb.rootChilds)
                .ForEach(function (x) { return moduleItem.items.push(x); });
            // subscribe to changes
            this._moduleMainChildCrumbItemsSubscription = ko.getObservable(item.breadCrumb, "rootChilds").subscribe(function (e) {
                moduleItem.items.removeAll();
                Enumerable.From(item.breadCrumb.rootChilds)
                    .ForEach(function (x) { return moduleItem.items.push(x); });
            });
        };
        ShellViewModel.prototype.bindModuleCrumbItems = function (item) {
            var _this = this;
            // add new
            Enumerable.From(item.breadCrumb.items)
                .ForEach(function (x) { return _this.crumbs.push(x); });
            // subscribe changes
            this._moduleCrumbItemsSubscription = ko.getObservable(item.breadCrumb, "items").subscribe(function (e) {
                Enumerable.From(_this.crumbs)
                    .ForEach(function (i) {
                    if (i.source == null || i.source.constructor != Model.NavigationNode) {
                        _this.crumbs.remove(i);
                    }
                });
                Enumerable.From(item.breadCrumb.items)
                    .ForEach(function (x) { return _this.crumbs.push(x); });
            });
        };
        //#endregion
        // #region ishell
        ShellViewModel.prototype.findNodeFor = function (symbol) {
            var node = this._navigation;
            if (node == null)
                return;
            var segments = symbol.fragment === "" ? [] : symbol.fragment.split("/");
            for (var i = 0; i < segments.length; i++) {
                var segment = segments[i];
                if (node.children != null) {
                    var item = Enumerable.From(node.children)
                        .FirstOrDefault(null, function (n) { return n.uri.fragment === segment; });
                    if (item != null)
                        node = item;
                }
            }
            return node;
        };
        ShellViewModel.prototype.findNodeByUID = function (symbol) {
            return this.findNodeForApp(this._navigation, symbol);
        };
        ShellViewModel.prototype.navigateTo = function (symbol) {
            this.navigateCommand.execute(symbol);
        };
        ShellViewModel.prototype.showDialog = function (dialog) {
            this.contentDialog = dialog;
        };
        ShellViewModel.prototype.hideDialog = function () {
            this.contentDialog = null;
        };
        //#endregion
        // #region add-widgets uk
        ShellViewModel.prototype.showAddWidgets = function () {
            this._widgetManager = new WidgetManager();
            this._widgetManager.showAddWidgetsPopUp(this);
        };
        ShellViewModel.prototype.checkShowAddWidgetsCondition = function () {
            for (var i = 0; i < this.groupedNavigationItems.length; i++) {
                if (this.sidebar.current === this.groupedNavigationItems[i].key) {
                    return this.groupedNavigationItems[i].showAddWidgets;
                }
            }
        };
        // #endregion
        // #region get cookie by name
        ShellViewModel.prototype.getCookie = function (cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        };
        return ShellViewModel;
    }(ViewModel.ViewModelBase));
    var instance = new ShellViewModel();
    return instance;
});
//export = ShellViewModel 
;
